// Aircon servicing demand in Singapore, July-September 2026, for
// /sg/aircon-servicing-singapore/aircon-servicing-demand-singapore-2026
//
// Copied from StringsSG's request records on 11 Oct 2026. Do not hand-edit: re-run
// the queries and re-copy.
//  - Requests are every aircon service request made in Singapore, whether or not it
//    became a booking, by request date in Singapore time.
//  - spendAdjusted.estimate2026 is an ESTIMATE, never a count: the requests this
//    year's requests-per-dollar would have produced at last year's customer
//    acquisition spending for the same month. Spend amounts are deliberately not
//    stored here. Always show the estimate next to the actual counts, labelled.
//  - prices are medians actually paid on one-time bookings with a technician
//    assigned (transport included). Published prices did not change.
//  - Temperatures: NEA monthly mean surface air temperature (Changi), data.gov.sg.
//  - Haze: 24-hour PSI as reported from NEA readings.

export const airconDemand2026Q3 = {
    asOf: '2026-10-10',

    // Actual requests by month.
    monthly: [
        { month: '2025-07', label: 'Jul 25', requests: 421, tempC: 29.1 },
        { month: '2025-08', label: 'Aug 25', requests: 368, tempC: 28.4 },
        { month: '2025-09', label: 'Sep 25', requests: 297, tempC: 28.0 },
        { month: '2025-10', label: 'Oct 25', requests: 255, tempC: 28.9 },
        { month: '2025-11', label: 'Nov 25', requests: 261, tempC: 28.2 },
        { month: '2025-12', label: 'Dec 25', requests: 215, tempC: 27.3 },
        { month: '2026-01', label: 'Jan 26', requests: 223, tempC: 27.0 },
        { month: '2026-02', label: 'Feb 26', requests: 148, tempC: 27.2 },
        { month: '2026-03', label: 'Mar 26', requests: 259, tempC: 28.2 },
        { month: '2026-04', label: 'Apr 26', requests: 308, tempC: 29.0 },
        { month: '2026-05', label: 'May 26', requests: 287, tempC: 28.7 },
        { month: '2026-06', label: 'Jun 26', requests: 387, tempC: 29.0 },
        { month: '2026-07', label: 'Jul 26', requests: 244, tempC: 29.0 },
        { month: '2026-08', label: 'Aug 26', requests: 254, tempC: 29.6 },
        { month: '2026-09', label: 'Sep 26', requests: 234, tempC: 29.3 },
    ],

    // Requests on 1-10 October 2026, and on the same days a month and a year earlier.
    earlyOctober: { requests2026: 95, sameDaysSep2026: 77, sameDaysOct2025: 77, changePct: 23 },

    // Requests per day, 1-4 Oct 2026 vs 5-10 Oct 2026 (the worst haze days).
    octoberDaily: { before: { label: '1-4 Oct', days: 4, requests: 25 }, haze: { label: '5-10 Oct', days: 6, requests: 70 } },

    // Actual requests by week (weeks start Monday). The last week is 6 days.
    weekly: [
        { week: '1 Jun', requests: 138 },
        { week: '8 Jun', requests: 88 },
        { week: '15 Jun', requests: 54 },
        { week: '22 Jun', requests: 71 },
        { week: '29 Jun', requests: 83 },
        { week: '6 Jul', requests: 43 },
        { week: '13 Jul', requests: 62 },
        { week: '20 Jul', requests: 54 },
        { week: '27 Jul', requests: 56 },
        { week: '3 Aug', requests: 60 },
        { week: '10 Aug', requests: 43 },
        { week: '17 Aug', requests: 61 },
        { week: '24 Aug', requests: 61 },
        { week: '31 Aug', requests: 65 },
        { week: '7 Sep', requests: 43 },
        { week: '14 Sep', requests: 48 },
        { week: '21 Sep', requests: 66 },
        { week: '28 Sep', requests: 48 },
        { week: '5 Oct', requests: 70, partial: true, days: 6 },
    ],

    hazeEvents: [
        { date: '2026-09-04', week: '31 Aug', label: 'PSI first unhealthy (4 Sep)' },
        { date: '2026-09-29', week: '28 Sep', psi: 167, label: 'PSI 167 (29 Sep)' },
        { date: '2026-10-09', week: '5 Oct', psi: 192, label: 'PSI 192 (9 Oct)' },
    ],

    // Year on year. actualChangePct compares counts; adjustedChangePct compares the
    // 2026 estimate at 2025 spending with 2025's actual requests.
    spendAdjusted: [
        { label: 'July', requests2025: 421, requests2026: 244, estimate2026: 558, actualChangePct: -42, adjustedChangePct: 33 },
        { label: 'August', requests2025: 368, requests2026: 254, estimate2026: 475, actualChangePct: -31, adjustedChangePct: 29 },
        { label: 'September', requests2025: 297, requests2026: 234, estimate2026: 792, actualChangePct: -21, adjustedChangePct: 167 },
    ],
    spendAdjustedTotal: { label: 'July-September', requests2025: 1086, requests2026: 732, estimate2026: 1825, actualChangePct: -33, adjustedChangePct: 68 },
    // Requests per dollar of acquisition spending, change on the previous month.
    requestsPerDollarMoM: { July: 22, August: 7, September: 64 },

    periods: ['Jul-Sep 2025', 'Apr-Jun 2026', 'Jul-Sep 2026'],

    // Share of requests that included each service (%). A request can include several.
    serviceMix: [
        { label: 'General Servicing', shares: [79.6, 75.4, 79.8] },
        { label: 'Chemical Wash', shares: [9.9, 11.3, 12.0] },
        { label: 'Gas Top Up', shares: [8.3, 10.3, 8.5] },
        { label: 'Aircon Repair', shares: [8.1, 8.5, 6.2] },
        { label: 'Condenser Cleaning', shares: [5.5, 7.0, 5.5] },
        { label: 'Chemical Overhaul', shares: [3.3, 4.8, 4.5] },
        { label: 'Drain Pipe Flush', shares: [1.6, 1.1, 1.4] },
    ],

    // Share of all requests in the period (%), for the Jul-Sep 2026 top six plus
    // Sengkang. Every figure has at least 20 requests behind it.
    areas: [
        { name: 'Tampines', shares: [4.7, 6.4, 5.5] },
        { name: 'Woodlands', shares: [3.2, 3.8, 4.6] },
        { name: 'Choa Chu Kang', shares: [3.7, 2.4, 4.4] },
        { name: 'Punggol', shares: [4.0, 4.1, 4.4] },
        { name: 'Yishun', shares: [2.9, 3.7, 4.2] },
        { name: 'Bedok', shares: [4.1, 3.6, 4.1] },
        { name: 'Sengkang', shares: [4.9, 5.6, 3.4] },
    ],

    // Medians actually paid (SGD), one-time bookings with a technician assigned.
    prices: [
        { period: 'Jul-Sep 2025', perBooking: 80, perUnitGeneral: 22 },
        { period: 'Apr-Jun 2026', perBooking: 90, perUnitGeneral: 25 },
        { period: 'Jul-Sep 2026', perBooking: 92, perUnitGeneral: 25 },
    ],

    sources: {
        temperature: 'https://data.gov.sg/datasets/d_755290a24afe70c8f9e8bcbf9f251573/view',
        haze: [
            { label: 'The Star, 8 Oct 2026', url: 'https://www.thestar.com.my/aseanplus/aseanplus-news/2026/10/08/singapore-shrouded-in-haze-psi-readings-in-the-unhealthy-range-across-the-island' },
            { label: 'Tempo, 9 Oct 2026', url: 'https://en.tempo.co/read/2121261/singapore-haze-hits-2026-high-as-psi-reaches-192' },
        ],
        nea: 'https://www.haze.gov.sg/',
    },
}
